<template lang="pug">
  #Profile
    .p-3.text-center.mb-5(
      v-if="data"
    )
      .mb-3.mt-3
        ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
          :profileUrl="profileImgUrl",
          :style="{ 'width': '120px', 'height': '120px' }",
          :changeProfile="true",
          @changeProfileImgHandler="changeProfileImgHandler"
        )
        input.d-none(
          type="file",
          accept="image/*",
          id="imageUpload",
          @change="fileUploadHandler()",
          ref="imageUploadInput"
        )
      p.mb-2 {{ data.chinese_last_name }} {{ data.chinese_first_name }}
      p.mb-2
        div
          i.fas.fa-map-marker-alt.mr-2
          span {{ data.stores[0].title }}
      hr
      p.mb-0
        i.fas.fa-users.mr-2
        span 顧客人數：{{ data.member_count }} 位

</template>

<script>
import { mapState } from 'vuex';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';

export default {
  name: 'ProfileIndex',
  components: {
    ProfilePhotoSticker
  },
  created() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    // 取得個人資料
    vm.$store.dispatch('sa_profile/getProfileHandler')
      .then(() => {
        vm.$swal.close();
      });
  },
  methods: {
    changeProfileImgHandler() {
      this.$refs.imageUploadInput.click();
    },
    fileUploadHandler() {
      const vm = this;
      const obj = vm.$refs.imageUploadInput;
      if (!obj.files[0]) return;

      vm.$swal.fire({
        title: '上傳中',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          vm.$swal.showLoading();
        }
      });

      const file = obj.files[0];
      const formData = new FormData();
      formData.append('file', file);

      vm.$store.dispatch('sa_profile/changeProfilePictureHandler', formData)
        .then(() => {
          obj.value = null;
          vm.$swal.close();
          vm.$snotify.success(null, '更換成功');
        });
    }
  },
  computed: {
    ...mapState({
      data: (state) => state.sa_profile.data,
      profileImgUrl: (state) => state.sa_profile.profileImgUrl
    })
  }
};
</script>

<style>

</style>
